import { configureStore } from "@reduxjs/toolkit";
import persistedReducer from "./rootReducers";

export const store = configureStore({
  reducer: persistedReducer,
});

export default store;
